/* eslint-disable */
/**
 * 基于高德地图封装的map工具
 */
;(function (factory, global) {
  /* eslint-env amd */
  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else if (typeof module === 'object' && module.exports) {
    module.exports = exports = factory();
  } else {
    global.Map = factory();
  }
}(function () {

  /**
   * Map构造函数
   * @param {String|Dom} el 地图初始化dom
   */
  function Map(el, options) {
    var defaultOptioin = {
      resizeEnable: true,
      zoom: 15,
      isHotspot: false
    };
    this.map = new window.AMap.Map(el, Object.assign(defaultOptioin, options || {}));
    this.markers = [];
  }

  Map.prototype = {
    constructor: Map,

    /**
     * 获取Amap实例
     */
    getInstance: function() {
      return this.map;
    },

    /**
     * 加载定位插件
     * @param {Object} options 定位插件配置项，参考高德地图配置
     * @param {Function} completeFn 定位成功回调函数
     * @param {Function} errorFn 定位失败回调函数
     * @return {Promise}
     */
    loadGeoPlugin: function(options, completeFn, errorFn) {
      var that = this;
      return new Promise(function (resolve, reject) {
        var defaultOptioin = {
          timeout: 10000,          // 超过10秒后停止定位，默认：无穷大
          panToLocation: true,
          showCircle: false,
          useNative:true
        };
        that.map.plugin('AMap.Geolocation', function() {
          geolocation = new AMap.Geolocation(Object.assign(defaultOptioin, options));
          that.map.addControl(geolocation);
          AMap.event.addListener(geolocation, 'complete', function (res) {
            completeFn && completeFn(res);
          });
          AMap.event.addListener(geolocation, 'error',  function(error) {
            reject(error);
          });
          
          that.geolocation = geolocation;
          resolve(geolocation);
        });
      })
    },

    /**
     * 定位
     */
    locate: function() {
      var that = this;
      if (!this.geolocation) {
        console.warn('未初始化高德定位插件');
        return;
      }

      return new Promise(function (resolve, reject) {
        that.geolocation.getCurrentPosition(function(status, result) {
          if (status === 'complete') {
            resolve(result);
          } else {
            reject(result);
          }
        });
      });
    },

    /**
     * 创建点标记
     * @param {Object} options marker配置项
     * @param {String|Dom} content 自定义infowindow内容
     * @return {AMap.Marker}
     */
    createMarker: function(options, container, content) {
      if (!options || !isObject(options)) {
        console.warn('Function[createMarker]: Parameter options must be an object.');
      } else if (!options.position) {
        console.warn('Function[createMarker]: Parameter options must contain position attribute.');
      } else {
        var marker = new AMap.Marker(Object.assign({
          map: this.map,
          topWhenClick: true
        }, options));
        marker.content = content || '';
    
        this.markers.push(marker);
        container && isArray(container) && container.push(marker);
        return marker;
      }
    },

    /**
     * 创建信息窗体
     */
    createInfowindow: function(options) {
      var infoWindow = new AMap.InfoWindow(Object.assign({
        isCustom: false,  //使用自定义窗体
        content: '',  //传入 dom 对象，或者 html 字符串
        offset: new AMap.Pixel(16, -50)
      }, options));

      this.infoWindow = infoWindow;
      return infoWindow;
    },

    /**
     * 清空地图上的点标记
     */
    clearMarkers: function(markerList) {
      var markers = markerList || this.markers;
      if (markers.length === 0) return;
      for (var index = 0; index < markers.length; index++) {
        var marker = markers[index];
        this.map.remove(marker);
      }
      markers = [];
    },

    toggleMarkers: function(state, markers) {
      markers = markers || this.markers;
      for (var index = 0; index < markers.length; index++) {
        var marker = markers[index];
        state
          ? marker.show()
          : marker.hide()
      }
    }
  }

  function noop() {}

  function isObject(obj) {
    return obj === Object(obj);
  }

  function isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
  }

  return Map;
}, this))
